<template>
  <v-container>
    <v-row :dense="dense">
      <v-col
        cols="12"
        md="6"
      >
        <validated-text-field
          v-model="user.first_name"
          field-name="first_name"
          rules="required"
          type="text"
          autofocus
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <validated-text-field
          v-model="user.last_name"
          field-name="last_name"
          rules="required"
          type="text"
        />
      </v-col>

      <v-col
        cols="12"
        md="4"
      >
        <date-field
          v-model="user.birth_date"
          field-name="birth_date"
          rules="date"
        />
      </v-col>

      <v-col
        cols="12"
        md="4"
      >
        <validated-text-field
          v-model="user.birth_place"
          field-name="birth_place"
          rules=""
          type="text"
        />
      </v-col>

      <v-col
        cols="12"
        md="4"
      >
        <validated-text-field
          v-model="user.mother_name"
          field-name="mother_name"
          rules=""
          type="text"
        />
      </v-col>

      <v-col
        cols="12"
        md="6"
      >
        <validated-text-field
          v-model="user.phone"
          field-name="phone"
          rules=""
          type="text"
        />
      </v-col>

      <v-col
        cols="12"
        md="6"
      >
        <validated-text-field
          v-model="user.mobile"
          field-name="mobile"
          rules="required"
          type="text"
        />
      </v-col>

      <v-col cols="12">
        <validated-text-field
          v-model="user.address"
          field-name="address"
          rules="required"
          type="text"
        />
      </v-col>

      <v-col cols="12">
        <validated-text-field
          v-model="user.email"
          field-name="email"
          rules="required"
          type="text"
        />
      </v-col>

      <v-col cols="12">
        <validated-text-field
          v-model="user.emergency_contact"
          field-name="emergency_contact"
          type="text"
        />
      </v-col>

      <v-col
        cols="12"
        md="6"
      >
        <v-checkbox
          v-model="user.public_privatedata"
          :label="$t('fields.public_privatedata')"
          dense
        />
      </v-col>

      <v-col
        cols="12"
        md="6"
      >
        <v-checkbox
          v-model="user.notifications_on"
          :label="$t('fields.notifications_on')"
        />
      </v-col>

      <v-col
        cols="12"
        md="6"
      >
        <v-checkbox
          v-model="user.logbook_glider_on"
          :label="$t('fields.logbook_glider_on')"
        />
      </v-col>

      <v-col
        cols="12"
        md="6"
      >
        <v-checkbox
          v-model="user.logbook_general_on"
          :label="$t('fields.logbook_general_on')"
        />
      </v-col>

      <v-col
        cols="12"
        md="6"
      >
        <v-checkbox
          v-model="user.newsletter_on"
          :label="$t('fields.newsletter_on')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'EditUser',
    props: {
      user: Object,
      dense: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>
